import React, { useState, useEffect } from 'react';
import Styles from './Navigation.module.scss';

const Navigation = ({ navigations, activeIndex, setActiveIndex }) => {
  const [animationClass, setAnimationClass] = useState('');

  useEffect(() => {
    setAnimationClass(Styles.fadeIn);
  }, [activeIndex]);

  const handleClick = (index) => {
    setAnimationClass(Styles.fadeOut);
    setActiveIndex(index);
  };

  return (
    <div className={Styles.navigation}>
      {navigations.map((item, index) => (
        <div key={index}>
          <button
            className={`${Styles.navigation__btn} ${activeIndex === index ? Styles[`navigation__btn--active-0`] : ''}`}
            onClick={() => handleClick(index)}
            disabled={item.new}
          >
            {/* {item.icon} */}
            <span className={Styles.navigation__btn__text}>{item.text}</span>
            {item.new && (
              <span className={Styles.navigation__btn__badge}>Coming soon</span>
            )}
          </button>
          {activeIndex === index && (
            <div className={`${Styles.right} ${animationClass}`}>
              <div className={Styles.right__header}>
                <p className={Styles.right__header__text}>
                  {navigations[activeIndex].description}
                </p>
              </div>
              <div className={Styles.right__image}>
                <img src={navigations[activeIndex].src} alt="content image" />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Navigation;
